<template>
    <div>
        <div class="form-group bmd-form-group search-area m-0 mb-2">
            <div class="row">
                <div class="col-12 col-lg-4 col-md-3  d-inline-block mt-2">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">دسته بندی :</span>
                        </div>
                        <vs-select :data="categories" :mode="'create'"
                                   :header="{multiple: false, label: 'name'}"
                                   @onChange="onSelectCategory"></vs-select>
                    </div>
                </div>
                <div class="col-12 col-lg-4 col-md-3  mt-2">
                    <div class="input-group">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fa fa-search"></i>
                    </span>
                        </div>
                        <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput"
                               v-model="searchString">
                    </div>
                </div>
                <div class="col-12 col-lg-2 col-md-3 p-0 mt-2 text-center">
                    <button class="btn btn-success" @click="onModalButtonClick">ثبت محصول جدید</button>
                </div>
                <div class="col-12 col-lg-2 col-md-3 p-0 mt-2 text-center">
                    <button class="btn btn-success" @click="onAssignProductsClicked">ثبت محصولات تامین کننده</button>
                </div>
            </div>
        </div>
        <div class="row" v-if="listView">
            <!--<div class="col-lg-12 mt-3 mb-1">
                <div class="category-item" v-for="item in categories">
                    <h4>{{item.name}}</h4>
                </div>
            </div>-->
            <div class="col-lg-8 offset-lg-2" v-for="(item, index) in products">
                <div :class="{active: assignObj.productIds.indexOf(item.id) >= 0}" class="card list"
                     @click="onCardClicked($event, index)">
                    <div class="row">
                        <div class="col-md-6">
                            <strong>{{item.productName}}</strong>
                        </div>
                        <div class="col-md-2">
                            <span>واحد: </span>
                            <span v-if="units[item.unitId-1] !== undefined">{{units[item.unitId-1].unitName}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-lg-4 col-sm-6 product-container" v-for="(item, index) in products">
                <div :class="{active: assignObj.productIds.indexOf(item.id) >= 0}" class="card product mt-2 mb-2"
                     @click="onCardClicked($event, index)">
                    <div class="row p-2">
                        <div class="col-8">
                            <h5>{{item.productName}}</h5>
                            <!--<span>موجودی انبار:</span>
                            <span>{{item.stock}}</span>-->
                            <!--<span>تعداد:</span>
                            <span v-if="item.unitVal === undefined || item.unitVal === ''">0</span>
                            <span v-else>{{item.unitVal}}</span>-->
                            <span>واحد:</span>
                            <span v-if="units[item.unitId-1] !== undefined"> {{units[item.unitId-1].unitName}}</span>
                            <br>
                            <span>بارکد:</span>
                            <span> {{item.barcode}}</span>
                        </div>
                        <div class="col-4">
                            <img class="view-image" :src="item.imageAddress!==null && item.imageAddress !='' ? validateImageUrl(item.imageAddress) :noImageUrl()">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12" :style="[autoload ? {'height': '125px'} : {'height': 'initial'}]">
                <div class="sk-circle" id="loading"
                     :style="[autoload ? {'margin': '20px 0'} : {'margin': '100px auto'}]">
                    <div class="sk-circle1 sk-child"></div>
                    <div class="sk-circle2 sk-child"></div>
                    <div class="sk-circle3 sk-child"></div>
                    <div class="sk-circle4 sk-child"></div>
                    <div class="sk-circle5 sk-child"></div>
                    <div class="sk-circle6 sk-child"></div>
                    <div class="sk-circle7 sk-child"></div>
                    <div class="sk-circle8 sk-child"></div>
                    <div class="sk-circle9 sk-child"></div>
                    <div class="sk-circle10 sk-child"></div>
                    <div class="sk-circle11 sk-child"></div>
                    <div class="sk-circle12 sk-child"></div>
                </div>
            </div>
            <div v-if="!autoload && products.length < dataCount" class="col-lg-12 text-center mb-3"
                 @click="getProducts">
                <button class="btn btn-success">نمایش محصولات بیشتر</button>
            </div>
            <div class="modal fade" id="productModal" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-warning-grad glow-warning">
                            <h5 v-if="params.mode === 'create'" class="modal-title text-white" id="voucherTitle">ایجاد
                                محصول</h5>
                            <h5 v-if="params.mode === 'edit'" class="modal-title text-white" id="voucherTitle">ویرایش
                                محصول</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body mt-3">
                            <div class="row">
                                <div class="col-lg-6 offset-lg-3 mb-2">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">دسته بندی</span>
                                        </div>
                                        <vs-select :data="categories"
                                                   :mode="'create'"
                                                   :header="{multiple: false, label: 'name'}"
                                                   @onChange="onCategoryChange"></vs-select>
                                    </div>
                                </div>
                                <div class="col-lg-3 text-right">
                                    <button class="btn btn-primary bg-danger-grad border-0"
                                            @click="onAddCategoryClicked" data-toggle="tooltip" data-placement="bottom"
                                            title="افزودن دسته بندی">
                                        <i class="fa fa-plus"></i>
                                    </button>
                                </div>
                                <div class="col-lg-12 mt-3 mt-lg-0">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">نام محصول</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="product.productName">
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">واحد</span>
                                        </div>
                                        <vs-select :data="units" :selected-val="preselectedUnit"
                                                   :mode="'create'" :header="{multiple: false, label: 'unitName'}"
                                                   @onChange="onUnitChange"></vs-select>
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">بارکد</span>
                                        </div>
                                        <input class="form-control" type="number" v-model="product.barcode">
                                    </div>
                                </div>
                                <div class="col-12 text-center">
                                    <div class="">
                                        <small class="d-flex justify-content-center">فقط فایلهای عکسی، تکسی، زیپ، پی دی اف قابل بارگزاری هستند</small>
                                        <small> (jpg/jpeg/png/txt/doc/docx/zip/rar/pdf)</small>
                                        <span class="" v-for="item in documentList">
                                    <hr/>
                                            <img :src="item.newImage" class="profile-image">
                                       (<i class="fa fa-trash clickable" title="حذف فایل ضمیمه" @click="deleteAtachFile(item)"></i>)
                                </span>
                                    </div>
                                    <input type="file" id="fileUpload" class="d-none"
                                           @change="onImageChange($event)">
                                    <label for="fileUpload" class="btn btn-info btn-round mb-3 clickable">بارگذاری
                                        فایل</label>
                                </div>
                            </div>
                            <!--<div class="table-responsive">
                                <table class="table table-hover table-striped">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th>نام محصول</th>
                                        <th class="text-center">قیمت</th>
                                        <th class="text-center">تعداد</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item,index) in cart">
                                        <td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>
                                        <td>{{item.productName}}</td>
                                        <td class="text-center">
                                            <input class="form-control" type="number" v-model="item.price">
                                        </td>
                                        <td class="text-center">
                                            <input class="form-control" type="number" v-model="item.unitVal">
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <h4 class="text-center mt-5" v-if="cart.length < 1">محصولی ثبت نشده است!</h4>
                            </div>-->
                        </div>
                        <div class="modal-footer d-block mt-3">
                            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                            <button type="button" class="btn btn-danger mr-2" @click="onModalDelete">حذف</button>
                            <button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import VsSelect from '../_framework/VsSelect.vue';
    import EventBus from "../_framework/event-bus.js";

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#productModal").modal("show");
    });

    export default {
        name: 'assign-product-to-provider',
        components: {
            VsSelect,
        },
        data() {
            return {
                products: [],
                units: [],
                categories: [],
                preselectedUnit: {},
                params: {
                    mode: 'create'
                },
                queryParams: {
                    pageSize: 18,
                    pageIndex: 0,
                    name: "",
                    showAll: true,
                    outsourceId: 0
                },
                searchString: "",
                modalProductName: "",
                product: {
                    productName: "",
                    unitId: 0,
                    barcode: "",
                    productImages: []
                },

                listView: false,
                autoload: false,

                assignObj: {
                    productIds: [],
                    outsourceId: 0
                },
                dataCount: 0,
                newImageCliked: false,
                isSending: false,
                documentList: null,
                helpDocumentModel: null,
            }
        },
        mounted() {
            this.autoload = JSON.parse(localStorage.getItem("autoload"));
            this.listView = JSON.parse(localStorage.getItem("listView"));
            EventBus.$on('listView', value => {
                this.listView = value;
            });
            this.assignObj.outsourceId = parseInt(this.$route.params.id);
            this.queryParams.outsourceId = parseInt(this.$route.params.id);
            new BaseService('product').getList(this.queryParams).then(response => {
                this.products = response.data.data;
                this.dataCount = response.data.count;
                for (let item of this.products) {
                    if (item.forSelectedOutsource) {
                        this.assignObj.productIds.push(item.id);
                    }
                }
                $("#loading").hide();
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.data.message, this.$noty);
            });
            new BaseService('units').getAll().then(response => {
                this.units = response.data;
            }).catch(error => {
                Utils.handleErrorWithNotification(error.data.message, this.$noty);
            });

            new BaseService('categories').getAll().then(response => {
                this.categories = response.data;
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });

            if (JSON.parse(localStorage.getItem("autoload"))) {
                $(window).on("scroll", () => {
                    if (Utils.onBottomReached() && this.products.length < this.dataCount) {
                        $("#loading").show();
                        this.getProducts();
                    }
                });
            }
            /*new BaseService('categories').getAll().then(response => {
                this.categories = response.data.data;
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.data.message, this.$noty);
            });*/
        },
        methods: {
            getProducts() {
                this.queryParams.pageIndex++;
                $("#loading").show();
                new BaseService('product').getList(this.queryParams).then(response => {
                    this.products.push.apply(this.products, response.data.data);
                    for (let item of this.products) {
                        if (item.forSelectedOutsource) {
                            this.assignObj.productIds.push(item.id);
                        }
                    }
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });
            },
            onSelectCategory(val) {
                let queryParamscat = {
                    name: "",
                    showAll: false,
                    pageSize: 18,
                    pageIndex: 0,
                    categoryId: val.id
                };
                // this.queryParams.categoryId = val.id;
                // this.queryParams.pageIndex = 0;
                $("#loading").hide();
                new BaseService('product', '/get').getList(queryParamscat).then(response => {

                    this.products = response.data.data;
                    for (let item of this.products) {
                        if (item.forSelectedOutsource) {
                            this.assignObj.productIds.push(item.id);
                        }
                    }
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });

            },

            onCategoryChange(e) {
                this.product.categoryId = e.id;
            },
            onUnitChange(e) {
                this.product.unitId = e.id;
            },
            onSearchInput() {
                this.queryParams.name = this.searchString;
                this.queryParams.pageIndex = 0;
                let queryParams2 = {
                    pageSize: 18,
                    pageIndex: 0,
                    name: this.searchString,
                    showAll: true,
                    outsourceId: parseInt(this.$route.params.id)
                };
                $("#loading").hide();
                new BaseService('product').getList(queryParams2).then(response => {
                    this.products = response.data.data;
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });
            },
            onCardClicked(e, index) {
                if (this.products[index].outsourceId != null) {
                    if (confirm("این محصول توسط تامین کننده دیگری ثبت شده است، آیا میخواهید آن را به این تامین کننده اختصاص دهید؟")) {
                        if (this.assignObj.productIds.indexOf(this.products[index].id) < 0) {
                            this.assignObj.productIds.push(this.products[index].id);
                        } else {
                            let i = this.assignObj.productIds.indexOf(this.products[index].id);
                            this.assignObj.productIds.splice(i, 1);
                        }
                    }
                } else {
                    if (this.assignObj.productIds.indexOf(this.products[index].id) < 0) {
                        this.assignObj.productIds.push(this.products[index].id);
                    } else {
                        let i = this.assignObj.productIds.indexOf(this.products[index].id);
                        this.assignObj.productIds.splice(i, 1);
                    }
                }
            },
            onRemoveProductClicked(index) {
                for (let item of this.products) {
                    if (item.productName === this.cart[index].productName) {
                        /*item.count = 0;*/
                        item.unitVal = 0;
                        item.price = item.originalPrice;
                    }
                }
                this.cart.splice(index, 1);

            },
            onModalButtonClick() {
                this.product.productImages = [];
                this.documentList = null;
                this.helpDocumentModel = null;
                $("#productModal").modal("show");
                this.params.mode = 'create';
            },
            onModalDelete() {
                if (confirm("آیا از حذف این محصول اطمینان دارید؟")) {
                    new BaseService('product').delete(this.product.id).then(response => {
                        this.$noty.warning("با موفقیت حذف شد!");
                        $("#productModal").modal("hide");
                        $("#productModal").modal("hide");
                        new BaseService('product').getList(this.queryParams).then(response => {
                            this.products = response.data.data;
                            $("#loading").hide();
                        }).catch(error => {
                            // error
                            Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        });
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });

                }
            },
            onModalOk() {
                if (this.params.mode === 'create') {
                    this.onCreate(this.product);
                } else {
                    this.onUpdate(this.product);
                }
            },
            onCreate(product) {
                if (!this.isSending) {
                    this.isSending = true;
                    product.rowVersion = this.generateUuid();
                    new BaseService('product').create(product).then(response => {
                        this.$noty.success("موفقیت آمیز!");
                        $("#productModal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        new BaseService('product').getList(this.queryParams).then(response => {
                            this.products = response.data.data;
                            $("#loading").hide();
                        }).catch(error => {
                            // error
                            Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        });
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });
                }
            },
            onUpdate(product) {
                if (!this.isSending) {
                    this.isSending = true;
                    new BaseService('product').update(product).then(response => {
                        this.$noty.success("موفقیت آمیز!");
                        $("#productModal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        new BaseService('product').getList(this.queryParams).then(response => {
                            this.products = response.data.data;
                            $("#loading").hide();
                        }).catch(error => {
                            // error
                            Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        });
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });
                }
            },
            onAssignProductsClicked() {
                if (!this.isSending) {
                    this.isSending = true;
                    new BaseService('product', '/assigntooutsource').create(this.assignObj).then(response => {
                        this.$noty.success("محصولات با موفقیت به تامین کننده انتساب داده شد!");
                        this.$router.push({name: 'provider'});
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });
                }
            },
            onAddCategoryClicked() {
                $("#productModal").modal("hide");
                this.$router.push({name: 'category'});
            },
            onImageChange(e) {
                let files = e.target.files;
                let app = this;
                if (files && files[0]) {
                    this.newImageCliked = true;
                    for (let item of files) {
                        let extension = item.name.slice((item.name.lastIndexOf(".") - 1 >>> 0) + 2);
                        let reader = new FileReader();
                        reader.onload = function (e) {
                            // $("#bannerImg").attr("src", e.target.result);
                            let a = e.target.result;
                            // let img = document.getElementById('docImg');
                            // img.src = e.target.result;
                            let bb = {};
                            bb.name = item.name;
                            bb.address = a.substring(a.indexOf(',') + 1, a.length);
                            bb.extension = extension;
                            bb.newImage = e.target.result;
                            app.isSending = true;
                            new BaseService("Product", "/CreateProductImage").create(bb).then(response => {
                                bb.documentId = response.data;
                                // let attach = {documentId: response.data};
                                app.product.productImages.push(response.data);
                                app.isSending = false;
                                app.helpDocumentModel = bb;
                            }).catch(error => {
                                app.isSending = false;
                                app.$noty.error("متاسفانه خطایی رخ داده است." + error.data);
                                console.log(error)
                                // Utils.handleErrorWithNotification("خطا!! لطفا پارامترها را مجددا بررسی کنید", this.$noty);
                            });

                        };
                        reader.readAsDataURL(item);
                        // } else {
                        //     alert("لطفا فایل عکس بارگذاری کنید");
                        // }
                    }
                }
            },
            deleteAtachFile(item) {
                this.product.productImages.splice(this.product.productImages.indexOf(item.documentId), 1);
                this.documentList.splice(this.documentList.indexOf(item), 1);
                console.log(this.product.productImages)
            },


        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            next();
        },
        onModalButtonClick() {
            $("#productModal").modal("show");
            this.params.mode = 'create';
        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#productModal").hasClass("show")) {
                $("#productModal").modal("hide");
                next(false);
            } else {
                next();
            }

        },
        watch: {
            helpDocumentModel(val) {
                if (this.helpDocumentModel != null) {
                    if (this.documentList === null) {
                        this.documentList = [];
                    }
                    this.documentList.push(val);
                }
            }
        },

    }
</script>

<style lang="scss">
    .vs-select {
        flex: 1;
    }

    .v-select .dropdown-toggle {
        padding: 4px 0 4px;
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
    }

    .vs-select .dropdown-toggle::after {
        display: none;
    }

    .v-select .dropdown-toggle .clear {
        margin-top: 5px;
    }
</style>